<template>
  <div class="content-page">
    <!-- Start content -->
    <div class="content">
      <div class="container-fluid">
        <div class="page-title-box"></div>
        <!-- end row -->
        <div class="row">
          <!-- end col -->
          <div class="col-lg-9">
            <div class="card">
              <div class="card-body">
                <ul class="list-inline widget-chart m-t-20 m-b-15 text-center">
                  <li class="list-inline-item">
                    <h6 class="card-text">{{message}}</h6>
                    <h4 class="mb-0 text-center" v-show="chart">Total: NGN {{totalRevenue}}</h4>
                  </li>
                </ul>
                <canvas v-show="chart" id="bar"></canvas>
                <div v-if="spinner" class="text-center">
                  <p>
                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-3">
            <!-- <h4 class="mt-0 header-title text-center">Statistics</h4> -->
            <p class="mt-0 header-title text-center">
              <font color="white">Statistics</font>
            </p>
            <div class="card">
              <div class="card-body">
                <h6 class="mb-0 text-center">
                  <i class="ti-wallet"></i> NEXT PAYOUT
                </h6>
                <h4 v-show="!loadNextPayout" class="mb-0 text-center">NGN {{nextPay}}</h4>
                <h4 v-if="loadNextPayout" class="mb-0 text-center">
                  <i class="fa fa-spinner fa-spin"></i>
                </h4>
                <div class="dropdown-divider"></div>
                <br />
                <h6 class="mb-0 text-center">
                  <i class="fas fa-angle-double-down"></i>
                </h6>
                <br />
                <div class="dropdown-divider"></div>
                <br />
                <br />
                <h4 class="mt-0 header-title text-center">
                  <i class="far fa-credit-card"></i> TOTAL COLLECTED
                </h4>
                <h4 class="mb-0 text-center">NGN {{totalRevenue}}</h4>
                <br />
                <div class="dropdown-divider"></div>
                <br />
                <p
                  class="card-text"
                >So far you've received over NGN {{totalRevenue}} with iRecharge! Thank you for using iRecharge.</p>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
    <!-- content -->
  </div>
</template>
<script>
import Vuex from "vuex";
import axios from "vue-axios";
import Axios from "axios";
import funcs from "./functions";
export default {
  data: function() {
    return {
      chart: null,
      chartData: null,
      totalRevenue: "0.0",
      nextPay: "0.0",
      message: "",
      funcs,
      spinner: false,
      loadNextPayout: false
    };
  },

  methods: {
    changeChart: function() {
      this.spinner = true;
      const app = this;
      let username = sessionStorage.getItem("username");
      let userid = sessionStorage.getItem("userid");
      let end_date = funcs.formattedDate(new Date());
      let start_date = funcs.getThirtyDaysAgo();

      let requiredDate = funcs.getAllDates(start_date, end_date);

      let passcode = app.hash(username);

      if (username != null && userid != null) {
        this.axios
          .post("https://irecharge.com.ng/api/collections/graph.php", {
            action: "graph",
            username,
            user_id: userid,
            start_date,
            end_date,
            passcode
          })
          .then(response => {
            if (response.data.status == "0" && response.data.transactions) {
              //Get the daily arrays
              let daily = funcs.getDailyTransactions(
                response.data.transactions,
                requiredDate
              );

              //Calculate the total Revenue
              app.totalRevenue = funcs.formatNumber(
                funcs.getTotalRevenue(daily.data)
              );

              //Create the chart by passing the two arrays
              app.createChart(daily.labels, daily.data);

              app.message =
                "Revenue for " +
                funcs.formattedDateText(new Date(start_date)) +
                " - " +
                funcs.formattedDateText(new Date(end_date));
            } 
            else if(response.data.status == "0" && response.data.transactions == null)
            {
                app.nullifyChart();
                if (!response.data.transactions) 
                {
                  app.message = "There are no recent transactions.";
                }
            }
            else
            {
              app.nullifyChart();
              if (response.data.message) {
                app.$noty.error(response.data.message);
              }
              // if (!response.data.transactions) {
              //   app.message = "There are no recent transactions.";
              // }
            }
            app.spinner = false;
          })
          .catch(function(error) {
            app.$noty.error("Error occured.");
            app.nullifyChart();
            app.spinner = false;
          });
      } else {
        app.spinner = false;
        app.$noty.error("Login to Continue.");
        app.$router.push("login");
        //window.location.assign("http://localhost:8080/login")
      }
    },
    nullifyChart() {
      if (this.chart) {
        this.chart = null;
      }
    },
    hash(username) {
      let passcode = "123NDSx";
      let encrypted = CryptoJS.HmacSHA512(username, passcode);
      return encrypted.toString();
    },
    createChart(labels, data) {
      this.chart = funcs.createChart(labels, data);
    },
    setNextPayout() {
      this.loadNextPayout = true;
      const app = this;
      let username = sessionStorage.getItem("username");
      let user_id = sessionStorage.getItem("userid");
      let passcode = this.hash(username);
      if (username != null && user_id != null) {
        this.axios
          .post(
            "https://irecharge.com.ng/api/collections/get_next_payout.php",
            {
              action: "get_next_payout",
              username,
              user_id,
              passcode
            }
          )
          .then(response => {
            if (response.data.status == "0") {
              app.nextPay = funcs.formatNumber(response.data.amount);
            } else {
              if (response.data.message) {
                app.$noty.error(response.data.message);
              }
            }
            app.loadNextPayout = false;
          })
          .catch(function(error) {
            app.$noty.error("Error occured.");
            app.loadNextPayout = false;
          });
      } else {
        app.loadNextPayout = false;
        app.$noty.error("Login to Continue.");
        app.$router.push("login");
      }
    }
  },
  mounted() {
    //Show the chart
    this.changeChart();

    //Show the next payout
    this.setNextPayout();
  }
};
</script>
<style scoped>
</style>